import { events } from "@/common/constants";
import useEvent from "./useEvent";
import { wait } from "../common";
import { useRef } from "react";

export default function useDelayedLoaderAnimation(fn, delay) {
  const called = useRef(false);

  useEvent(events.LOADING_OUT_COMPLETE, async () => {
    if (called.current) return;
    called.current = true;
    await wait(delay);
    fn();
    called.current = false;
  });
}
